import { createContext, useContext } from "react";
const MessageContext = createContext(null);
export function useMessageContext() {
    const ctx = useContext(MessageContext);
    if (!ctx) {
        return {};
    }
    return ctx;
}
export { MessageContext };
